export const UNEXPECTED_ERROR = 'Error inesperado';
export const UPLOAD_IMAGES_ERROR = 'Error subiendo las imágenes';
